module.exports = __webpack_public_path__ + "static/media/SizzleReel.7970711f.mp4";